import styled from '@emotion/styled';

export const Container = styled.span`
  float: left;
  margin-right: 4px;
  color: ${props => props.theme.color.red};
`;
